import React from "react";
import CorePaper from "../paper";
import styles from "./CompleteCard.module.css";
import Lottie from "lottie-react";
import completedAnimation from "./completed.json";
import { Typography } from "@mui/material";
import { CoreButton } from "../button/Button";
import { CoreCardProps } from "./Card";

type CoreCompletedCardProps = {
	title: string;
	description: string;
	buttonText: string;
	onClick: () => void;
	children?: React.ReactNode;
} & Omit<CoreCardProps, "children">;

export default function CoreCompleteCard({
	title,
	description,
	buttonText,
	onClick,
	children,
	...props
}: CoreCompletedCardProps) {
	return (
		<CorePaper className={`${styles.card} ${props.className || ""}`} {...props}>
			<Lottie className={styles.animation} animationData={completedAnimation} loop={false} />
			<div className={styles.content}>
				<div className={styles.textArea}>
					<Typography variant="h1" className={styles.title}>
						{title}
					</Typography>
					<Typography className={styles.description}>{description}</Typography>
				</div>
				{children}
				<CoreButton onClick={onClick}>{buttonText}</CoreButton>
			</div>
		</CorePaper>
	);
}
